import packageJson from '../../package.json';
import defaultConfig from './default.config';
import local from './local.config';
import develop from './develop.config';
import staging from './staging.config';
import production from './production.config';
import copy from './copy.config';
import qa from './qa.config';
import uat from './uat.config';
import dr from './dr.config';

export const environments = {
  STG: 'staging',
  QA: 'qa',
  UAT: 'uat',
  DEV: 'develop',
  COPY: 'copy',
  PROD: 'production',
  DR: 'dr',
  LOCAL: 'local',
};

export function getEnv() {
  const host = window.location.host || '';
  if (
    host.includes('archway-staging.archre.com') ||
    host.includes('archway-stg.archre.com') ||
    host.includes('facultative-stg.archre.com')
  )
    return environments.STG;
  else if (
    host.includes('archway-dev.archre.com') ||
    host.includes('archway-dev1.archre.com') ||
    host.includes('archway-develop.archre.com') ||
    host.includes('facultative-dev.archre.com') ||
    host.includes('facultative-dev1.archre.com')
  )
    return environments.DEV;
  else if (
    host.includes('archway-qa.archre.com') ||
    host.includes('archway-qa1.archre.com') ||
    host.includes('facultative-qa.archre.com') ||
    host.includes('facultative-qa1.archre.com')
  )
    return environments.QA;
  else if (
    host.includes('archway-uat.archre.com') ||
    host.includes('archway-uat1.archre.com') ||
    host.includes('facultative-uat.archre.com') ||
    host.includes('facultative-uat1.archre.com')
  )
    return environments.UAT;
  else if (
    host.includes('archway-copy.archre.com') ||
    host.includes('facultative-copy.archre.com') ||
    host.includes('archway-copy1.archre.com') ||
    host.includes('facultative-copy1.archre.com')
  )
    return environments.COPY;
  else if (host.includes('localhost')) return environments.LOCAL;
  else if (
    host.includes('archway-dr.archre.com') ||
    host.includes('facultative-dr.archre.com')
  )
    return environments.DR;
  else if (
    host.includes('archway.archre.com') ||
    host.includes('facultative.archre.com')
  )
    return environments.PROD;
}

const config = {
  test: defaultConfig,
  [environments.LOCAL]: local,
  [environments.DEV]: develop,
  [environments.QA]: qa,
  [environments.UAT]: uat,
  [environments.STG]: staging,
  [environments.COPY]: copy,
  [environments.DR]: dr,
  [environments.PROD]: production,
};

const env = getEnv();

export default {
  ...defaultConfig,
  NAMESPACE: packageJson.name,
  VERSION: packageJson.version,
  ENVIRONMENT: env,
  ...(process.env.NODE_ENV === 'test' ? {} : config[env]),
};

export const actions = {
  create: 'create',
  edit: 'edit',
  view: 'view',
  completeDraft: 'complete',
  completeUWApprove: 'underwriterapproved',
  completeFinalize: 'approved',
  renew: 'renew',
  endorse: 'endorse',
  bind: 'bind',
  copy: 'copy',
  inprogress: 'inprogress',
  bound: 'bound',
};
